import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PropertyInfoSection = ({ formData, errors, onChange, onSelectChange }) => {
  const propertyTypeOptions = [
    { value: 'Residential', label: 'Residential' },
    { value: 'Commercial', label: 'Commercial' },
    { value: 'Industrial', label: 'Industrial' }
  ];

  const homeOwnerOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border elevation-1 overflow-hidden">
      <div className="p-6 border-b border-border bg-muted/30">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="Home" size={20} />
          Property Information
        </h2>
        <p className="text-sm text-muted-foreground mt-1">
          Provide details about the property
        </p>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            label="Property Type"
            options={propertyTypeOptions}
            value={formData?.propertyType}
            onChange={(value) => onSelectChange('propertyType', value)}
            placeholder="Select property type"
            error={errors?.propertyType}
            required
            description="Type of property being referred"
            className="md:col-span-2"
          />
          <Select
            label="Home Owner"
            options={homeOwnerOptions}
            value={formData?.homeOwner}
            onChange={(value) => onSelectChange('homeOwner', value)}
            placeholder="Select home owner status"
            error={errors?.homeOwner}
            required
            description="Is the customer a home owner?"
            className="md:col-span-2"
          />
          <Input
            label="Property Address"
            type="text"
            name="propertyAddress"
            value={formData?.propertyAddress}
            onChange={onChange}
            placeholder="456 Property Lane"
            error={errors?.propertyAddress}
            required
            className="md:col-span-2"
          />
          <Input
            label="City"
            type="text"
            name="propertyCity"
            value={formData?.propertyCity}
            onChange={onChange}
            placeholder="Honolulu"
            error={errors?.propertyCity}
            required
          />
          <Input
            label="State"
            type="text"
            name="propertyState"
            value={formData?.propertyState}
            onChange={onChange}
            placeholder="Hawaii"
            error={errors?.propertyState}
            required
            disabled
          />
          <Input
            label="ZIP Code"
            type="text"
            name="propertyZip"
            value={formData?.propertyZip}
            onChange={onChange}
            placeholder="96813"
            error={errors?.propertyZip}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default PropertyInfoSection;